class UserSearchInlineTakeButtonListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('click', context.selector, function (){



            let tr = $(this).closest('tr');

            let json_data = JSON.parse(tr.attr('data-json'));

            console.log(json_data);

            let panel = $(this).closest('.panel');

            context.operations_interface.populateUserFieldsFromJson(panel, json_data);


            let selectors = context.operations_interface.selectors;

            panel.find(selectors.getUserSearchInlineResultsSelector()).empty();
            panel.find('.user_input').removeClass('hide');
        });



    }

}